import { createFileRoute } from '@tanstack/react-router'

import { Page } from '@/components/page'
import { PasskeysCard } from '@/features/auth/PasskeysCard'
import { TokensCard } from '@/features/tokens/TokensCard'

export const Route = createFileRoute('/settings')({ component: SettingsPage })

function SettingsPage() {
  return (
    <Page
      title="Passkeys & tokens"
      description="Who can sign in, and what machines may read the library."
    >
      <div className="flex max-w-2xl flex-col gap-6">
        <PasskeysCard />
        <TokensCard />
      </div>
    </Page>
  )
}
